// import * as Sentry from '@sentry/browser';
import Cookies from 'js-cookie';
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/blur-up/ls.blur-up';
const _throttle = require('lodash.throttle');
const _debounce = require('lodash.debounce');
import $ from 'jquery';

// core version + navigation, pagination modules:
import Swiper from 'swiper/bundle';
import { Navigation, Pagination } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

window.jQuery = $;
window.$ = $;
window.lazySizes = lazySizes;
lazySizes.cfg.blurupMode = 'auto';
// window.Sentry = Sentry;
window.Cookies = Cookies;
window._throttle = _throttle;
window._debounce = _debounce;

window.Swiper = Swiper;
window.Navigation = Navigation;
window.Pagination = Pagination;


